import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

// Lazy loading de componentes - usando named exports correctamente
const MapaInteractivoPage = lazy(() => import('@feature/monitor').then(m => ({ default: m.MapaInteractivoPage })));
const UmbralRiesgoSettings = lazy(() => import('@feature/monitor').then(m => ({ default: m.UmbralRiesgoSettings })));
const EdithUmbralRiesgo = lazy(() => import('@feature/monitor').then(m => ({ default: m.EdithUmbralRiesgo })));
import { ROUTES } from '@shared/constants/routes.constants';

/**
 * Rutas principales de la aplicación
 */
export const monitorRoutes: RouteObject[] = [
  {
    path: ROUTES.MONITOR.PLUVIAL,
    element: <MapaInteractivoPage />,
  },
  {
    path: ROUTES.MONITOR.THRESHOLD,
    element: <UmbralRiesgoSettings />,
  },
  {
    path: ROUTES.MONITOR.EDIT_THRESHOLD.STORM,
    element: <EdithUmbralRiesgo phenomenType={"storm"} />,
  },
  {
    path: ROUTES.MONITOR.EDIT_THRESHOLD.WIND,
    element: <EdithUmbralRiesgo phenomenType={"wind"} />,
  },
  {
    path: ROUTES.MONITOR.EDIT_THRESHOLD.FLOOD,
    element: <EdithUmbralRiesgo phenomenType={"flood"} />,
  },
  {
    path: ROUTES.MONITOR.EDIT_THRESHOLD.FROST,
    element: <EdithUmbralRiesgo phenomenType={"frost"} />,
  },
  {
    path: ROUTES.MONITOR.EDIT_THRESHOLD.HIGH_TEMPERATURES,
    element: <EdithUmbralRiesgo phenomenType={"high_temperatures"} />,
  },
  {
    path: ROUTES.MONITOR.EDIT_THRESHOLD.LOW_TEMPERATURES,
    element: <EdithUmbralRiesgo phenomenType={"low_temperatures"} />,
  },
  {
    path: ROUTES.MONITOR.EDIT_THRESHOLD.PRECIPITATION_24H,
    element: <EdithUmbralRiesgo phenomenType={"accumulated_precipitation_24h"} />,
  },
  {
    path: ROUTES.MONITOR.EDIT_THRESHOLD.PRECIPITATION_12H,
    element: <EdithUmbralRiesgo phenomenType={"accumulated_precipitation_12h"} />,
  },
  {
    path: ROUTES.MONITOR.EDIT_THRESHOLD.PRECIPITATION_6H,
    element: <EdithUmbralRiesgo phenomenType={"accumulated_precipitation_6h"} />,
  },
  {
    path: ROUTES.MONITOR.EDIT_THRESHOLD.PRECIPITATION_3H,
    element: <EdithUmbralRiesgo phenomenType={"accumulated_precipitation_3h"} />,
  },
];
